/* import __COLOCATED_TEMPLATE__ from './icon-button.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();